<script>
import Cookies from 'js-cookie'

export default {
  name: 'ImportExcel',
  data() {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + this.url
      }
    }
  },
  props: {
    title: {
      type: String,
      default: '导入Excel'
    },
    isUploading: {
      type: Boolean,
      default: false
    },
    updateSupport: {
      type: Number,
      default: 0
    },
    headers: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  methods: {
    show() {
      this.excelVisible = true;
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmItemOrganizationItem/export', {
      //   ...this.queryParams
      // }, `物料属性_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
        this.$emit('onSuccess', { info })
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
      this.$emit('onChange', { info })
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    }
  }
}
</script>

<template>
  <!-- 上传文件 -->
  <a-modal
    :title="upload.title"
    :visible="excelVisible"
    @ok="importExcelHandleCancel"
    @cancel="importExcelHandleCancel"
    class="import-excel"
  >
    <a-upload-dragger
      name="file"
      accept=".xlsx, .xls"
      :multiple="true"
      :headers="upload.headers"
      :action="upload.url + '?updateSupport=' + upload.updateSupport"
      @change="importExcelHandleChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        请将文件拖拽到此处上传
      </p>
      <p class="ant-upload-hint">
        支持单个或批量上传，也可以点击后选择文件上传
      </p>
    </a-upload-dragger>
  </a-modal>
</template>

<style scoped lang="less">
.import-excel{
  /deep/.ant-modal-body{
    height: 200px;
  }
}

</style>
